import { Theme } from '@eversports/react-components/design-tokens/theme'
import ErrorBox from '@eversports/react-components/primitives/ErrorBox'
import Flex from '@eversports/react-components/primitives/Flex'
import Icon, { Icons } from '@eversports/react-components/primitives/Icon'
import RadioButton from '@eversports/react-components/primitives/RadioButton'
import Text from '@eversports/react-components/primitives/Text'
import { makeStyles } from '@mui/styles'
import React from 'react'

import { Localized } from '../../localization/react'
import { StoredBankAccount as StoredBankAccountType } from '../../typings/Payment'

interface StyleProps {
  isVerified: boolean
  isSelected: boolean
}

const useStyles = makeStyles((theme: Theme) => ({
  root: ({ isVerified, isSelected }: StyleProps) => ({
    border: theme.borders.strong,
    borderColor: isSelected && isVerified ? theme.palette.primary.main : theme.palette.divider,
    borderRadius: theme.borderRadii.default,
    padding: `calc(${theme.spacing(1)} / 2) ${theme.spacing(1)}`,
    cursor: isVerified ? 'pointer' : 'default',
    opacity: isVerified ? 1 : 0.7,
  }),
}))

interface Props {
  bankAccount: StoredBankAccountType
  isSelected?: boolean
  isVerified?: boolean
}

const StoredBankAccount: React.FC<React.PropsWithChildren<Props>> = ({ bankAccount, isSelected, isVerified }) => {
  const classes = useStyles({ isVerified: Boolean(isVerified), isSelected: Boolean(isSelected) })
  const bankAccountDisplayNumber = `** **** **** **** **** ${bankAccount.last4}`

  return (
    <Flex flexDirection="column" verticalSpacing="default">
      <Flex alignItems="center" horizontalSpacing="dense" is="label" fullWidth className={classes.root}>
        <RadioButton name="pspPaymentMethodId" value={bankAccount.pspId} disabled={!isVerified} />
        <Icon size="large" icon={Icons.BANK} />
        <Text size="small">{bankAccountDisplayNumber}</Text>
      </Flex>
      {!isVerified && (
        <ErrorBox>
          <Text size="small" color="danger">
            <Localized id="sepa-unverified-bank-account" />
          </Text>
        </ErrorBox>
      )}
    </Flex>
  )
}

StoredBankAccount.defaultProps = {
  isVerified: true,
  isSelected: false,
}

export default StoredBankAccount
